import React, { useEffect, useRef, useState, } from "react";
import "../App.css";
import styled from "styled-components";
import "react-toastify/dist/ReactToastify.css";
import NameSetting from "./settings/NameSetting";
import StyleSelection from "./settings/StyleSelection";
import StyleSettings from "./settings/styleSettings/StyleSettings.js";
import Player from "./Player";
import Navbar from "./Navbar";
import { handleWAVDownloadClick } from "../util/PlayerUtil.js";
import Download from "./popover/content/Download";
import Popover from "./popover/Popover";
import PopoverContentContainer from "./popover/PopoverContentContainer";
import Controls from "./Controls";
import Title from "./Title";
import { 
    FaEdit, 
    FaItunesNote, 
} from "react-icons/fa";
import {
    MELOGY_TRANSPARENT,
    MELOGY_ALMOST_OPAQUE,
} from "../style/colors";

const MainContainer = styled.div`
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const LowerMain = styled.div`
    height: 56px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    background-color: ${MELOGY_TRANSPARENT}; 
    z-index: 2;
`;

const BlurredBackground = styled.div`
    width: 100%;
    height: 112px; 
    position: fixed;
    background-color: ${MELOGY_ALMOST_OPAQUE};
    ${({ position }) => (position === 'top' ? 'top: 0;' : 'bottom: 0;')}
    display: flex;
    align-items: center;
    flex-direction: column;
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    z-index: 2;
`;

function Main({
    songs,
    setSelectedSong,
    selectedSong,
    selectedInstruments,
    setSongName,
    isNameUnique,
    createAndFetchMidi,
    toggleLeftSideBar,
    styles,
    selectedStyle,
    updateStyle,
    setSelectedStyle,
}) {
    const initialSongCreatedRef = useRef(false);
    const [downloadPopoverOpen, setDownloadPopoverOpen] = useState(false);
    const [styleSettingsIsOpen, setStyleSettingsIsOpen] = useState(false);
    const midi = selectedSong ? selectedSong.midi : null;

    const toggleDownloadPopover = () => {
        setDownloadPopoverOpen(!downloadPopoverOpen);
    };

    const closeOverlay = () => {
        setSelectedStyle(null);
    };

    useEffect(() => {
        if (songs.length === 0 && !initialSongCreatedRef.current) {
            createAndFetchMidi();
            initialSongCreatedRef.current = true; 
        }
    }, [songs.length]); 

    return (
        <MainContainer>
            <BlurredBackground 
                position="top" 
                height={styleSettingsIsOpen && selectedStyle ? "calc(100vh - 104px)" : "112px"}
            >
                <Navbar selectedSong={selectedSong} />
                <Title text="SONG TITLE" icon={FaEdit} />
                <NameSetting
                    selectedSong={selectedSong}
                    setSongName={setSongName}
                    isNameUnique={isNameUnique}
                />
                <Title text="STYLE OF MUSIC" icon={FaItunesNote} />
            </BlurredBackground>
            <StyleSelection
                styles={styles}
                setSelectedStyle={setSelectedStyle}
                setStyleSettingsIsOpen={setStyleSettingsIsOpen}
            />
            {styleSettingsIsOpen && selectedStyle && (
                <StyleSettings 
                    styles={styles}
                    selectedStyle={selectedStyle} 
                    closeOverlay={closeOverlay}
                    updateStyle={updateStyle}
                    setSelectedStyle={setSelectedStyle}
                    setStyleSettingsIsOpen={setStyleSettingsIsOpen}
                />
            )}
            <BlurredBackground>
                <LowerMain>
                    <Player
                        songs={songs}
                        setSelectedSong={setSelectedSong}
                        selectedInstruments={selectedInstruments}
                        selectedSong={selectedSong}
                        createAndFetchMidi={createAndFetchMidi}
                        selectedStyle={selectedStyle}
                    />
                </LowerMain>
                <Controls
                    createAndFetchMidi={createAndFetchMidi}
                    toggleLeftSideBar={toggleLeftSideBar}
                    toggleDownloadPopover={toggleDownloadPopover}
                    midi={midi}
                />
            </BlurredBackground>
            {downloadPopoverOpen && (
                <Popover
                    content={
                        <PopoverContentContainer
                            title="DOWNLOAD"
                            component={
                                <Download
                                    handleWAVDownloadClick={() =>
                                        handleWAVDownloadClick(
                                            midi,
                                            selectedInstruments
                                        )
                                    }
                                    selectedSong={selectedSong}
                                />
                            }
                        />
                    }
                    onClose={toggleDownloadPopover}
                    zIndex={1000}
                />
            )}
        </MainContainer>
    );
}

export default Main;